import { useIntl } from "react-intl";
import Switch from "@mui/material/Switch";
import TableViewOutlinedIcon from "@mui/icons-material/TableViewOutlined";
import StackedLineChartOutlinedIcon from "@mui/icons-material/StackedLineChartOutlined";
import LabelLang from "component/LabelLang/label-lang";

function VisualizationHeader({ selectedIndicator, show, onShowChange }) {
  const intl = useIntl();

  return (
    <div className="row gx-md-2 gx-0 gy-3 gy-md-0 d-flex justify-content-md-between align-items-md-center">
      <div className="col-md-8">
        <div className="title-content">
          <h5>
            {selectedIndicator ? (
              <LabelLang
                id="name"
                defaultValue={selectedIndicator.name}
                translations={selectedIndicator.indicatorTranslations}
              />
            ) : (
              <h5 className="text-black-50 fw-semibold">
                [{intl.formatMessage({ id: "select-indicator" })}
                ...]
              </h5>
            )}
          </h5>
        </div>
      </div>
      <div className="col-md-4">
        <div className="switch-cases">
          <h6 className={`${show ? "active" : ""}`}>
            <StackedLineChartOutlinedIcon />
            {intl.formatMessage({ id: "charts" })}
          </h6>
          <Switch
            defaultChecked
            onChange={(e) => onShowChange(e.target.checked)}
          />
          <h6 className={`${!show ? "active" : ""}`}>
            <TableViewOutlinedIcon />
            {intl.formatMessage({ id: "tables" })}
          </h6>
        </div>
      </div>
    </div>
  );
}

export default VisualizationHeader;
